<app-page-header
    title = "Gyakorlati modul logok"
    subtitle = "Itt találhatóak az össszes gyakorlati modulhoz tartozó logok."
    style = "margin-bottom: 20px;"
></app-page-header>

<app-practical-module-logs
    [entityType]="'all'"
    class = "practical-module-logs"
></app-practical-module-logs>